import clsx from 'clsx';

//hooks
import { useTransformStringOnOffset } from '@/utils/hooks/format/useTransformString';

import PropTypes from 'prop-types';

import { DEFAULT_POST_CONFIG } from '@/lib/posts/defaultPostConfig';
import { getPostType, LI_POST_TYPES, POST } from '@/lib/posts/postTypes';
//lib
import { LINKEDIN } from '@/lib/socialProfile';

//components
import Post from '@/components/base/Post';
import HoverLabelAndAlbums from '@/components/base/Post/HoverLabelAndAlbums';

const LinkedinPost = ({
    data,
    isLoading,
    config = undefined,
    openViewer = undefined,
    isExport = false,
    remoteMedia = false,
    handleLabelsEvent = undefined,
    handleAlbumsEvent = undefined,
    postConfig = { hasHover: true, hasFooter: true, showLabels: true, showAlbums: true },
    showHeader = true
}) => {
    const mergedPostConfig = { ...DEFAULT_POST_CONFIG, ...postConfig };
    const { OffsetReplace } = useTransformStringOnOffset();
    const type = getPostType({ network: LINKEDIN, type: data?.type });

    if (isLoading) {
        return <Post.Placeholder postType={POST} isExport={isExport} />;
    }

    return (
        <div className="w-full">
            {showHeader && <Post.Header data={data} isExport={isExport} />}
            <Post
                data={data}
                config={config}
                isLoading={isLoading}
                isExport={isExport}
                className={clsx('w-full bg-white', {
                    'p-0.5': !mergedPostConfig?.hasFooter,
                    'px-2 pt-2': mergedPostConfig?.hasFooter,
                    'dark:bg-icoDarkMode-anthracite': !isExport
                })}>
                {({ referenceElement }) => (
                    <>
                        <Post.Content className="w-full">
                            {mergedPostConfig?.hasHover ? (
                                <HoverLabelAndAlbums
                                    openViewer={openViewer}
                                    referenceElement={referenceElement}
                                    handleLabelsEvent={handleLabelsEvent}
                                    handleAlbumsEvent={handleAlbumsEvent}
                                    showLabels={mergedPostConfig?.showLabels}
                                    showAlbums={mergedPostConfig?.showAlbums}
                                    socialProfile={data?.social_profile}
                                />
                            ) : null}
                            {type && type !== LI_POST_TYPES.TYPE_STATUS ? (
                                <Post.PostTypeIcon
                                    type={type === LI_POST_TYPES.TYPE_PHOTO ? 'content' : type}
                                    isExport={isExport}
                                />
                            ) : null}
                            {data && data?.promoted_post ? <Post.Promoted /> : null}

                            <Post.Status
                                withMedia={
                                    type !== LI_POST_TYPES.TYPE_STATUS &&
                                    type !== LI_POST_TYPES.TYPE_LINK &&
                                    type !== LI_POST_TYPES.TYPE_POLL &&
                                    type !== LI_POST_TYPES.TYPE_VIDEO
                                }
                                remoteMedia={remoteMedia}
                                formattedCaption={
                                    <OffsetReplace
                                        text={data?.caption_formatted}
                                        components={Object.assign(
                                            {
                                                a: <span className="text-icoBlue" />,
                                                br: <br />
                                            },
                                            data?.tags?.map((tag, id) => (
                                                // eslint-disable-next-line jsx-a11y/anchor-has-content
                                                <a
                                                    key={id}
                                                    href={tag.link}
                                                    className="text-icoBlue"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                />
                                            ))
                                        )}
                                    />
                                }
                            />
                        </Post.Content>
                        {mergedPostConfig?.hasFooter ? <Post.Footer type={type} /> : null}
                    </>
                )}
            </Post>
        </div>
    );
};

LinkedinPost.propTypes = {
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    config: PropTypes.object,
    openViewer: PropTypes.func,
    addLabel: PropTypes.func,
    addAlbum: PropTypes.func
};

export default LinkedinPost;
